import { RdevService } from "../../services/RdevService";
import { setTrober, sendMessage } from "./WaitResult";

export const CHANGE_OPERATION_MODE = '@@operation_mode/CHANGE_OPERATION_MODE';
export const FETCH_OPERATION_MODE = '@@operation_mode/FETCH_OPERATION_MODE';

export const fetchOperationMode = () => {
	return async dispatch => {
		const result = await RdevService.getOperationMode();
		dispatch({
			type: FETCH_OPERATION_MODE,
			payload: { mode: result.data.operationMode }
		});
	}
};

export const changeOperationMode = (mode) => {
	return async dispatch => {
		dispatch(setTrober(true));
		RdevService.setOperationMode(mode)
			.then(data => {
				dispatch(sendMessage(data.success, "OperationMode", null, data.message, data));
				dispatch({
					type: CHANGE_OPERATION_MODE,
					payload: { mode: mode }
				});
			})
			.catch(error => dispatch(sendMessage(false, "OperationMode", null, "Не удалось изменить режим работы RDEV.", error)))
			.finally(() => dispatch(setTrober(false)));
	}
};